<div class="AMFlightInfo-segment" [ngClass]="{ 'AMFlightInfo-segment-irops': segmentsModel?.type == 'irops' }">
  <div class="text-center  am-visible" [ngClass]="{'opacity-50': !isrb && !islarge,
       'fs-22px': !isrb && !islarge,
       'fs-18px-rb': isrb,
       'AMFlightInfo-txt-dur-rb-o': islarge}" *ngIf="showDuration">
    <span> {{ 'flightInfo.Duration' | translate }} - {{ time }}</span>
  </div>
  <div class="d-flex justify-content-between align-items-center mb-3 mt-3 lineHeight gap-2" *ngIf="firstSegment">
    <div class="content-time" *ngIf="firstSegment?.segment?.departureDateTime || firstSegment?.departureDateTime">
      <div *ngIf="islarge" class="AMFlightInfo-txt-date mb-1" >{{ departureTime  | localizedDate:'dd MMM' }}</div>
      <div *ngIf="isAfectedFirstSeg && segModify && !islarge" class="textLineHigth opacity-75">{{ departureOriginal | date:'H:mm' }}</div><!-- Hora Original -->
      <div class="fs-32-42px"
        [ngClass]="{
          'text-am-yellow-rebrand': isOnBoarding,
          'text-yellow': isAfectedFirstSeg && statusIrops == 'Delayed',
          'text-green': isAfectedFirstSeg && statusIrops == 'Early'
        }">{{ departureTime | date:'H:mm' }}</div><!-- Hora Afected -->
      <div *ngIf="islarge" class="AMFlightInfo-txt-des mt-2">{{ departureAirport }}</div>
      <div *ngIf="!islarge" class="fs-24px my-3">{{ departureAirport }}</div>
    </div>
    <div class="content-segments" [ngClass]="{ 'mx-3-3k': segmentsModel?.type == 'irops' }">
      <div [ngClass]="classObjectSeperatatorLarge">
        <div [ngClass]="classObjectAMFlightCircleDot"></div>

        <div [ngClass]="classObjectSeperatatorLineLarge">
          <div class="" [ngClass]="classObjectAMFlightInfoLine">
            <span *ngIf=" hasConnect.length > 0" [ngClass]="classObjectAMFlightCircleConexion">
              {{ segments.length -1 }}
            </span>
          </div>

        </div>
        <div [ngClass]="classObjectAMFlightCircleDot"></div>

      </div>
      <div class="text-center " *ngIf="hasConnect && cterminal" [ngClass]="{ 'am-label': segmentsModel?.type == 'irops',
           'fs-18px': isrb, 'fs-22px': !isrb}">
        <span class="fs-18px-oprb">{{ connections }} </span>
        <span class="AMFlightInfo-terminal" *ngIf="isrb && boardingTerminal">{{ boardingTerminal }}</span>
        <span class="AMFlightInfo-time fs-18px-oprb" *ngIf="segmentsModel?.type == 'irops' || isrb">{{ time }}</span>
      </div>
    </div>
    <div class="content-time" *ngIf="lastSegment">
      <div *ngIf="islarge" class="AMFlightInfo-txt-date AMFlightInfo-txt-right mb-2">{{ arrivalTime  | localizedDate:'dd MMM'}}</div>
      <div *ngIf="isAfectedLastSeg && segModify && !islarge" class="textLineHigth opacity-75">{{ arrivalOriginal | date:'H:mm' }}</div><!-- Hora Original SABRE -->
      <div class="fs-32-42px" [ngClass]="{
          'AMFlightInfo-txt-right': islarge,
          'text-yellow': isAfectedLastSeg && statusIrops == 'Delayed',
          'text-green': isAfectedLastSeg && statusIrops == 'Early'
        }">
        {{ arrivalTime | date:'H:mm' }}</div><!-- Hora Afected -->
      <div *ngIf="islarge" class="AMFlightInfo-txt-des AMFlightInfo-txt-right mt-2">{{ arrivalAirport }}</div>
      <div *ngIf="!islarge" class="fs-24px my-3">{{ arrivalAirport }}</div>
    </div>
  </div>
</div>